import {
  ArrowLeft,
  ArrowRight,
  Blocks,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Compass,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  House,
  QrCode,
} from 'lucide-react';
import { createLucideIcon } from '../createLucideIcon';

// Navigation / layout icons.
export const ArrowBackIcon = /* #__PURE__ */ createLucideIcon('ArrowBack', ArrowLeft);
export const ArrowForwardIcon = /* #__PURE__ */ createLucideIcon('ArrowForward', ArrowRight);
// GAP: MUI ArrowDropDown is a filled triangle; Lucide only offers a chevron.
export const ArrowDropDownIcon = /* #__PURE__ */ createLucideIcon('ArrowDropDown', ChevronDown);
export const KeyboardArrowDownIcon = /* #__PURE__ */ createLucideIcon('KeyboardArrowDown', ChevronDown);
export const ExpandMoreIcon = /* #__PURE__ */ createLucideIcon('ExpandMore', ChevronDown);
export const ChevronLeftIcon = /* #__PURE__ */ createLucideIcon('ChevronLeft', ChevronLeft);
export const ChevronRightIcon = /* #__PURE__ */ createLucideIcon('ChevronRight', ChevronRight);
export const MoreHorizIcon = /* #__PURE__ */ createLucideIcon('MoreHoriz', Ellipsis);
export const MoreVertIcon = /* #__PURE__ */ createLucideIcon('MoreVert', EllipsisVertical);
export const HomeIcon = /* #__PURE__ */ createLucideIcon('Home', House);
export const ExploreIcon = /* #__PURE__ */ createLucideIcon('Explore', Compass);
export const OpenInNewIcon = /* #__PURE__ */ createLucideIcon('OpenInNew', ExternalLink);
export const WidgetsIcon = /* #__PURE__ */ createLucideIcon('Widgets', Blocks);
export const WidgetsOutlinedIcon = /* #__PURE__ */ createLucideIcon('WidgetsOutlined', Blocks);
export const QrCode2Icon = /* #__PURE__ */ createLucideIcon('QrCode2', QrCode);
